const Spinner = ({color="primary",text="Please wait..",withborder=false}) => {
	return (
		<div className="container-xxl flex-grow-1 container-p-y d-flex justify-content-center align-items-center">
			<div className="row">
				<div className={`col d-flex justify-content-center align-items-center flex-column ${withborder && 'border border-dashed border-primary' } rounded p-4`}>
					
					<div className={`sk-wave sk-${color}`}>
						<div className={`sk-wave-rect bg-${color}`} />
						<div className={`sk-wave-rect bg-${color}`}  />
						<div className={`sk-wave-rect bg-${color}`}  />
						<div className={`sk-wave-rect bg-${color}`}  />
						<div className={`sk-wave-rect bg-${color}`}  />
					</div>

  				<span className="text-primary fw-bold text-center  mt-1 s">
                    {text}
                </span>

				</div>
			</div>
		</div>
	);
};

export default Spinner;
